<div class="config-container shadow mt-4">
  <h4 (click)="toggleCollapse(SubStepEnum.Boards)" [ngClass]="{ active: subStep === SubStepEnum.Boards }"
    class="title configurator-subtitle collapse-button">
    <span>{{ 'fence.materials.boards' | translate }}</span>
  </h4>

  <!-- Si une lame est désactivée et qu'aucun devis n'est valide -->
  @if (!configuration.hasValidQuotation && configurationHasDisabledColors) {
  <span class="disabled-product pt-1 ml-4">{{ disableMessage }}</span>
  }

  <!-- Si une lame est désactivée et que le devis est valide -->
  @if (configuration.hasValidQuotation && configurationHasDisabledColors) {
  <span class="disabled-with-quotation-product pt-1 ml-4">{{ 'fence.materials.valid-quotation-message' | translate
    }}</span>
  }

  <!-- Si l'onglet est actif -->
  @if (subStep === SubStepEnum.Boards) {
    <div class="collapse-block">
      @for (configurationInstallation of configuration.configurationInstallations; track configurationInstallation.id) {
        <ng-casto-materials-installation-boards [configurationInstallation]="configurationInstallation"></ng-casto-materials-installation-boards>
      }
    </div>
  }
</div>
